import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';

// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';

// Import charts, all with Chart suffix
import { BarChart } from 'echarts/charts';
import { LineChart } from 'echarts/charts';

// import components, all suffixed with Component
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent
} from 'echarts/components';

// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { CanvasRenderer } from 'echarts/renderers';
import { getChartByDD } from 'y4/Y4Api';
import EChartsAdapter from 'y4/adapter/EChartsAdapter';

// Register the required components
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
  LegendComponent
]);

const EChartsPanel = ({ panel }) => {
  const [option, setOption] = useState(JSON.parse(panel.chart.option));

  useEffect(() => {
    getChartByDD(panel.dataCode, panel.chart.code).then(rt => {
      if (rt.isOk()) {
        var data = rt.data;
        const new_option = JSON.parse(panel.chart.option);
        const adapt = EChartsAdapter[new_option.name];
        if (adapt) {
          adapt({ panel, option: new_option, data });
          setOption(new_option);
        } else {
          setOption({
            error: 1,
            errorTitle: `No Adapter`,
            errorDescription: `No Adapter ${new_option.name} in EChartsAdapter`
          });
        }
      } else {
        setOption({
          error: 1,
          errorTitle: `Error ${rt.id}` + (rt.code ? `(${rt.code})` : ''),
          errorDescription: rt.message
        });
      }
    });
  }, []);

  return (
    option &&
    (option.error ? (
      <>
        <h5 className="mb-0 mt-1">{option.errorTitle}</h5>
        <div className="pt-3">{option.errorDescription}</div>
      </>
    ) : (
      <ReactEChartsCore
        echarts={echarts}
        option={option.option}
        style={{ height: option.height }}
      />
    ))
  );
};

EChartsPanel.propTypes = {
  panel: PropTypes.object
};

export default EChartsPanel;
